import { render, staticRenderFns } from "./shicimng.vue?vue&type=template&id=ba7bc3de&scoped=true"
import script from "./shicimng.vue?vue&type=script&lang=js"
export * from "./shicimng.vue?vue&type=script&lang=js"
import style0 from "./shicimng.vue?vue&type=style&index=0&id=ba7bc3de&prod&scoped=true&lang=css"
import style1 from "./shicimng.vue?vue&type=style&index=1&id=ba7bc3de&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba7bc3de",
  null
  
)

export default component.exports